var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.devices),function(device){return _c('device-card',{key:device.uid,attrs:{"device":device}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }